module.exports = __webpack_public_path__ + "static/media/food_and_beverage.daf68c2f.png";